/**
 * Tiny Zustand store for the command-palette open/closed state. Lives
 * on its own (not on layoutStore) so the palette mount is decoupled
 * from the rest of the chrome — features can call
 * `useCommandPalette.getState().openPalette()` without learning about
 * layout internals.
 *
 * State is named `isOpen` (not `open`) to avoid colliding with the
 * `openPalette` action — the two would have the same key under the
 * cleaner `open` naming, and the action would silently shadow the
 * boolean at runtime.
 */
import { create } from "zustand";

interface PaletteState {
  isOpen: boolean;
}
interface PaletteActions {
  openPalette: () => void;
  closePalette: () => void;
  togglePalette: () => void;
}

export const useCommandPalette = create<PaletteState & PaletteActions>()(
  (set) => ({
    isOpen: false,
    openPalette: () => set({ isOpen: true }),
    closePalette: () => set({ isOpen: false }),
    togglePalette: () => set((s) => ({ isOpen: !s.isOpen })),
  }),
);
